// The model has no clock: left alone it dates "today" at its training
// cutoff, and a window like "the last 10 days" lands months back. Every
// request appends the real moment to the system prompt so relative periods
// are counted from it. Whole seconds: the millisecond adds nothing and
// would make every prompt unique.

const CLOCK_NOTE =
  "The current date and time (RFC 3339, UTC). Count every relative period — today, the last 24 hours, the last 10 days — from it, never from your own sense of the date.";

export function withClock(
  prompt: string | undefined,
  now: Date,
): string | undefined {
  if (prompt === undefined) return undefined;
  const moment = `${now.toISOString().slice(0, 19)}Z`;
  return `${prompt}\n\n<now>${moment}</now>\n${CLOCK_NOTE}`;
}
